import { XMLValidator } from 'fast-xml-parser'

const IDP_NAME = 'idpName'
const AZURE = 'azure'
const OKTA = 'okta'
const OTHER = 'other'

const setFieldValuesForIdentityProvider = (values: any) => {
  const defaults = {
    azure: {
      emailAttribute: 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress',
      usernameAttribute: 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/givenname',
      familyNameAttribute: 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/surname'
    },
    okta: {
      emailAttribute: 'email',
      usernameAttribute: 'firstName',
      familyNameAttribute: 'lastName'
    },
    other: {
      emailAttribute: '',
      usernameAttribute: '',
      familyNameAttribute: ''
    }
  }
  const idpNameFieldValue = values[IDP_NAME]
  const isAutoFilled = shouldAutoFillOtherFields(idpNameFieldValue)

  // Only if we changed the idp name field, set the other fields accordingly
  // @ts-expect-error
  values['emailAttribute'] = isAutoFilled ? defaults[idpNameFieldValue].emailAttribute : ''
  // @ts-expect-error
  values['usernameAttribute'] = isAutoFilled ? defaults[idpNameFieldValue].usernameAttribute : ''
  // @ts-expect-error
  values['familyNameAttribute'] = isAutoFilled ? defaults[idpNameFieldValue].familyNameAttribute : ''
}

const shouldAutoFillOtherFields = (value: any) => {
  return [AZURE, OKTA].includes(value)
}

const getIdpName = (value: any) => {
  const idpNames = {
    azure: 'Azure Active Directory',
    okta: 'Okta',
    other: 'Other'
  }
  // @ts-expect-error
  return idpNames[value.toLowerCase()]
}

const validateXML = (value: any) => {
  let result
  try {
    result = XMLValidator.validate(value)
  } catch {}
  return result === true
}

const formatAsValidCognitoName = (name: any) => {
  // Trim to max length and remove whitespace/special characters other than _ and -
  return name?.replace(/[^\w-]/g, '').slice(0, 25)
}

export {
  IDP_NAME,
  AZURE,
  OKTA,
  OTHER,
  setFieldValuesForIdentityProvider,
  shouldAutoFillOtherFields,
  validateXML,
  getIdpName,
  formatAsValidCognitoName
}
